import React, { useState } from "react";

import { Typography, Button } from "design_system/src";
import { ReactComponent as WhatsApp } from "design_system/src//static/icons/whatsapp.svg";

export const WhatsappButton = ({ className } : { className?: string }) => {
    const handleClick = () => {
        window.open(`https://api.whatsapp.com/send?phone=${process.env.REACT_APP_WHATSAPP}`, "_blank");
    };

    return <div className={`${className ?? ""}`}>
        <Button variant="ghost" scale="small" onClick={handleClick} icon={<WhatsApp className="text_green_300" style={{ stroke: "none" }} /> }>
            <Typography weight="600" scale="medium" scaleMobile="medium" textColor="green_300">
                Contactar a mi asesor
            </Typography>
        </Button>
    </div>;
};
